/**
 * Row ceiling for synchronous CSV exports.
 *
 * Exports are rendered in a single page, so this value must stay at or below
 * ``LimitOffsetPagination.max_limit`` in ``api/mcl/utils/views.py``: a higher value
 * would be silently clamped by the API and truncate the file.
 *
 * @type {number}
 */
export const CSV_EXPORT_LIMIT = 20000;
